module.exports = __webpack_public_path__ + "static/media/IIT.83a50faa.png";